<template>
    <div>
        <div id="_div" class="w-100 px-5 py-4">
            <div id="Titulo_div">
                <h1>Citas Solicitadas</h1>

            </div>
            <div style="display: flex">
                <div class="col-12 padding-div-low">
                    <div class="area card-body">
                        <div class="row" id="formulario">
                            <div class="col-8"></div>
                            <div class="col-3" style="padding-left:0px;padding-right:1px;"><input type="text" v-model="nombreBusqueda" class="form-control" placeholder="Buscar" v-on:keyup.enter="filtrarCitas" /></div>
                            <div class="col-1" style="padding-left:0px;padding-right:1px;"><button class="form-control" @click="filtrarCitas"><i class="fa fa-search"></i></button></div>
                        </div>
                        <div class="row new-row">
                            <div class="col-10"></div>
                            <div class="col-2">
                                <button type="button" class="bottom-style form-control" value="Generar Reporte" @click="abrirModalFecha"><span style="margin-right:2px;">Imprimir Lista</span><i class="fa fa-file-pdf"></i></button>
                            </div>
                        </div>
                        <div class="row" id="tabla" style="margin-top:20px;">
                            <table class="table table-striped table-light table-hover" id="tablaCitas">
                                <thead class="table-header-global">
                                    <tr class="visible-element">
                                        <th>Folio<i class="fa fa-redo" @click="buscarCitas"></i></th>
                                        <th>Datos del Solicitante</th>
                                        <th>Trámites y Expedientes</th>
                                        <th>Fecha y Hora</th>
                                        <th>Notas del Solicitante</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody class='text-dark'>
                                    <tr v-for="Cita in Citas">
                                        <td>{{Cita.CitaId}}</td>
                                        <td>{{Cita.InformacionDeSolicitante.NombreCompleto}}<br />{{Cita.InformacionDeSolicitante.Telefono}}<br />{{Cita.InformacionDeSolicitante.CorreoElectronico}}</td>
                                        <td>
                                            <ul>
                                                <template v-for="Tramite in Cita.TramitesCita">
                                                    <li>{{Tramite.TipoTramite.Nombre}}.</li>
                                                    <li style="list-style-type:none"><ul> <li v-for="Expediente in Tramite.Expedientes"> {{Expediente.TipoDocumento_DBPJ.Nombre}} - {{Expediente.NumeroDeExpediente}} </li></ul></li>
                                                </template>
                                            </ul>

                                        </td>
                                        <td>{{Cita.AgendaBloque.FechaHoraString}}</td>
                                        <td>{{Cita.NotasDelSolicitante}}</td>
                                        <td><i class="fas fa-info-circle fa-2x" @click="verDetalleCita(Cita.CitaId)" /></td>
                                    </tr>
                                    <tr v-if="Citas.length == 0"><td colspan="5">No se encontraron citas pendientes en los siguientes 5 días hábiles.</td></tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="modal fade"
                             id="modalConfirmacion"
                             tabindex="-1"
                             role="dialog"
                             aria-labelledby="exampleModalLabel"
                             aria-hidden="true">
                            <div class="modal-dialog" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="tituloModalConfirmacion">Imprimir Lista</h5>
                                        <button type="button"
                                                class="close"
                                                data-dismiss="modal"
                                                aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div class="modal-body">
                                        <h5>
                                            <span id="cuerpoModalConfirmacion" class="col-form-label">Seleccione el día que desea imprimir.</span>
                                        </h5>
                                        <br />

                                        <input class="form-control" type="date" v-model="fechaReporte" v-bind:min="fechaInicial" v-bind:max="fechaFinal" />
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary" data-dismiss="modal"> Cancelar </button>
                                        <button type="button" class="btn btn-primary" id="botonModalConfirmacion" @click="imprimirReporte" data-dismiss="modal"> Imprimir </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import axios from 'axios'
  import store from '@/store/index'
  export default {
    data() {
      return {
        nombreBusqueda: "",
        _Citas: [],
        Citas: [],
        NumeroFilasPagina: 10,
        fechaReporte: null,
        fechaInicial: null,
        fechaFinal: null
      }
    },
    components: {
    },
    methods: {
      buscarCitas: function () { //Retorna una lista de citas programadas dentro del juzgado para los siguientes 5 días hábiles.
        var peticion = {
          "esPrueba": false,
          "NombreBusqueda": this.nombreBusqueda
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SICCIJ.funciones.ConsultaDeCitasRecepcion, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            //console.log(response)
            this._Citas = response.data.Citas
            this.Citas = this._Citas
            this.fechaInicial = response.data.FechaInicial.substring(0, 10);
            this.fechaReporte = this.fechaInicial;
            this.fechaFinal = response.data.FechaFinal.substring(0, 10);
            this.filtrarCitas();
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      },
      filtrarCitas: function () {
        //alert('filtrando');
        if (this.nombreBusqueda) {
          //alert('cool');
          let textoBusqueda = this.nombreBusqueda.toUpperCase();
          this.Citas = this._Citas.filter(cita => cita.InformacionDeSolicitante.NombreCompleto.toUpperCase().includes(textoBusqueda) || this._busquedaNumeroExpedienteCita(cita, textoBusqueda))
        } else {
          this.Citas = this._Citas
        }
      },
      _busquedaNumeroExpedienteCita(cita, textoBusqueda) {
        //console.log(cita)
        for (let tramiteCita of cita.TramitesCita) {
          for (let expediente of tramiteCita.Expedientes) {
            if (expediente.NumeroDeExpediente.includes(textoBusqueda)) { return true; }
          }
        }
        return false;
      },
      imprimirReporte: function () { //Muestra la tabla de citas en un archivo pdf
        var fechaFormateada = moment(this.fechaReporte, 'YYYY-MM-DD').format('L')
        var popupWin = window.open('', '_blank', 'location=no,left=100px');
        popupWin.document.open();
        popupWin.document.write('<html><head><title>Citas Solicitadas</title>');
        popupWin.document.write('<link rel="" href="/src/assets/favicon.ico">');
        popupWin.document.write('<link href="/static/css/bootstrap.min.css" rel="stylesheet">');
        popupWin.document.write('<link href="/static/css/all.min.css" rel="stylesheet">');
        popupWin.document.write('<link href="/static/css/bootstrap-table.min.css" rel="stylesheet">');
        popupWin.document.write('<style> tr { border-bottom: 2px solid ; }</style>')
        popupWin.document.write('</head><body >')
        popupWin.document.write('<h2>Citas Solicitadas para ' + fechaFormateada + '</h2>')

        popupWin.document.write('<table class="table table-striped table-light table-hover" id="tablaCitas">')
        var fechaReporte = this.fechaReporte;
        var resultados = "<tr><th>Número de Folio</th><th>Datos del Solicitante</th><th>Trámites y Expedientes</th><th>Fecha y Hora</th><th>Notas del Solicitante</th>";
        var infoExpedientes;
        var notas;
        //console.log(fechaReporte)
        this.Citas.forEach(function (cita) {
          //console.log(cita)
          if (cita.AgendaBloque.FechaBloque.substring(0, 10) == fechaReporte) {
            notas = "";
            infoExpedientes = "<ul>";
            cita.TramitesCita.forEach(function (tramite) {
              infoExpedientes += "<li>" + tramite.TipoTramite.Nombre + "</li>" + "<li style='list-style-type:none'><ul>"
              tramite.Expedientes.forEach(function (expediente) {
                infoExpedientes += "<li>" + expediente.TipoDocumento_DBPJ.Nombre + " - " + expediente.NumeroDeExpediente + "</li>";
              });
              infoExpedientes+="</ul></li>"
            });
            infoExpedientes += "</ul>"
            if (cita.NotasDelSolicitante != null) { notas = cita.NotasDelSolicitante; }
            resultados += "<tr>"
              + "<td>" + cita.CitaId + "</td>"
              + "<td>" + cita.InformacionDeSolicitante.NombreCompleto + "<br />" + cita.InformacionDeSolicitante.Telefono + "<br />" + cita.InformacionDeSolicitante.CorreoElectronico + "</td>"
              +"<td>"+infoExpedientes+"</td>"
              + "<td>"+cita.AgendaBloque.FechaHoraString+"</td>"
              + "<td style='max-width:25vw;'>"+notas+"</td>"
              + "</tr>";
          }
        });
        //console.log(resultados);
        resultados = resultados.split('style="display: none; opacity: 0;"').join('style="opacity: 1; display: table-row;"');
        resultados = resultados.split('style="opacity: 0; display: none;"').join('style="opacity: 1; display: table-row;"');

        popupWin.document.write(resultados);
        popupWin.document.write('</table>');
        popupWin.document.write('</body></html>');
        /*var css = '@page { size: landscape; }',
          head = popupWin.document.head || document.getElementsByTagName('head')[0],
          style = popupWin.document.createElement('style');

        style.type = 'text/css';
        style.media = 'print';

        if (style.styleSheet) {
          style.styleSheet.cssText = css;
        } else {
          style.appendChild(popupWin.document.createTextNode(css));
        }

        head.appendChild(style);
        */
        setTimeout(function () { popupWin.print(); }, 1000)
        popupWin.document.close();
        popupWin.focus();
        this.ImpresionConcluida = true;
      },
      verDetalleCita: function (citaId) {//Redirige a la página SICCIJ/DetalleDeCita, para marcar la disponibilidad de los expedientes de la cita.
        this.$router.push({
          name: 'DetalleDeCita',
          params: { citaId: citaId }
        })
      },
      abrirModalFecha: function () {//Abre un modal que solicita la fecha para reportear.
        $("#modalConfirmacion").modal();

      },
      paginarTabla: function (idTabla) {
        this.$nextTick(() => {
          PaginarTabla(idTabla, this.NumeroFilasPagina)
        })
      }
    }, mounted: function mounted() {
      this.buscarCitas();
    }
  }
</script>

<style scoped>
    .padding-div-low {
        padding-top: 40px;
    }

    .fas {
        cursor: pointer;
    }

    .new-row {
        margin-top: 20px;
    }

    .table-header-global{
      background-color: #004746;
    }

    .card-body {
        background-color: #bebebc;
        padding: 2em 2em 2em 2em !important;
    }

    .form-control {
        background-color: white;
        color: rgb(63, 62, 62);
        border: 1px solid #656161 !important;        
    }

    .bottom-style{
      background-color: red;
      color: white;
      border: 1px solid rgb(44, 44, 44);
      border-radius: 0px 0px 0px 0px;
    } 

</style>



// WEBPACK FOOTER //
// src/components/SICCIJ/Recepcion/CitasSolicitadas/CitasSolicitadas.vue